'use client';

import { useCallback } from 'react';

import type { PageViewTrackingRepository } from '../../../domain';
import { composeTrackPageViewUC } from '../../../domain';
import { useCompleteTrackingContext } from '../../contexts/complete-tracking/complete-tracking-context';

export const useTrackPageView = () => {
  const provider = useCompleteTrackingContext();

  const trackPageView = useCallback(
    (...args: Parameters<PageViewTrackingRepository>) =>
      composeTrackPageViewUC(provider)(...args),
    [provider],
  );

  return trackPageView;
};
